// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paywall-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 2100;
}

.paywall-card {
  width: min(480px, 100%);
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  animation: paywallModalIn 0.15s ease;
}

@keyframes paywallModalIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 640px) {
  .paywall-card {
    padding: 22px 16px;
  }

  .paywall-header h2 {
    font-size: 20px;
  }
}

.paywall-header {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.paywall-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.paywall-header p {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 14px;
  line-height: 1.45;
}

.paywall-benefits {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: var(--color-text-primary);
  font-size: 14px;
  line-height: 1.4;
}

.paywall-benefits li::before {
  content: '✓';
  margin-right: 8px;
  color: var(--color-accent-base);
}

.paywall-usage {
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  padding: 14px;
  text-align: center;
}

.paywall-usage p {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 13px;
  line-height: 1.4;
}

.paywall-usage p:first-child {
  margin-bottom: 4px;
}

.paywall-usage strong {
  color: var(--color-text-primary);
  font-weight: 600;
}

.paywall-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 4px;
}

.paywall-primary,
.paywall-secondary {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--color-border-input);
  font-family: inherit;
  font-size: 14px;
  cursor: pointer;
}

.paywall-primary {
  background: var(--color-accent-base);
  color: var(--color-text-on-accent);
  font-weight: 600;
}

.paywall-secondary {
  background: transparent;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.paywall-primary:hover {
  filter: brightness(0.96);
}

.paywall-secondary:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}
`, "",{"version":3,"sources":["webpack://./src/components/PaywallModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,oBAAoB;EACpB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC","sourcesContent":[".paywall-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  z-index: 2100;\n}\n\n.paywall-card {\n  width: min(480px, 100%);\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  animation: paywallModalIn 0.15s ease;\n}\n\n@keyframes paywallModalIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 640px) {\n  .paywall-card {\n    padding: 22px 16px;\n  }\n\n  .paywall-header h2 {\n    font-size: 20px;\n  }\n}\n\n.paywall-header {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.paywall-header h2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.paywall-header p {\n  margin: 0;\n  color: var(--color-text-secondary);\n  font-size: 14px;\n  line-height: 1.45;\n}\n\n.paywall-benefits {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  color: var(--color-text-primary);\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.paywall-benefits li::before {\n  content: '✓';\n  margin-right: 8px;\n  color: var(--color-accent-base);\n}\n\n.paywall-usage {\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  padding: 14px;\n  text-align: center;\n}\n\n.paywall-usage p {\n  margin: 0;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.paywall-usage p:first-child {\n  margin-bottom: 4px;\n}\n\n.paywall-usage strong {\n  color: var(--color-text-primary);\n  font-weight: 600;\n}\n\n.paywall-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.paywall-primary,\n.paywall-secondary {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid var(--color-border-input);\n  font-family: inherit;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.paywall-primary {\n  background: var(--color-accent-base);\n  color: var(--color-text-on-accent);\n  font-weight: 600;\n}\n\n.paywall-secondary {\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.paywall-primary:hover {\n  filter: brightness(0.96);\n}\n\n.paywall-secondary:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
